/* THE CART ACROSS DEVICES — AND ONE CART PER CUSTOMER (2026-10-07; lib/saved-cart.ts).
   The Online Store keeps the cart in this BROWSER's cookie: it does not follow a customer to another
   device, and it does not change when someone else signs in on this one. So every cart is tagged
   with its owner — the cart attribute `_swr_owner`, a one-way tag of the customer id, computed here
   and on the server the same way — and:
     · signed in, cart is theirs      → every change is saved on their account;
     · signed in, cart is EMPTY       → their saved cart (if any) is added back, once;
     · signed in, cart is SOMEONE ELSE's (another customer's tag) → it is cleared from this browser,
       never saved to them, and their own saved cart is loaded; the other customer's cart is already
       saved on THEIR account (every change was);
     · signed in, cart has no owner (a guest cart) → if they have a saved cart, the guest cart is
       cleared and theirs loaded; if not, the guest cart becomes theirs;
     · signed OUT with a cart that has an owner → the cart is cleared from this browser, so the next
       person starts empty; it stays saved on its owner's account.
   The server refuses to save any cart whose tag is not the signed-in customer's. */
(function () {
  var cfg = window.SWRFM_CART || {};
  var url = cfg.proxy || '/apps/swrfm/cart-sync';
  var OWNER = '_swr_owner';
  var J = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var origFetch = window.fetch, busy = false, timer = null, me = null;

  function call(path, body) { return origFetch.call(window, path, body ? { method: 'POST', credentials: 'same-origin', headers: J, body: JSON.stringify(body) } : { credentials: 'same-origin', headers: { Accept: 'application/json' } }); }
  function cart() { return call('/cart.js').then(function (r) { return r.json(); }); }
  function ownerOf(c) { return (c && c.attributes && c.attributes[OWNER]) || ''; }
  function tagOf(id) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode('swrfm-cart:' + id)).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('').slice(0, 16);
    });
  }
  function setOwner(tag) { var a = {}; a[OWNER] = tag; return call('/cart/update.js', { attributes: a }); }
  // Empty the browser's cart and drop its owner — the items stay saved on their owner's account.
  function wipe() { return call('/cart/clear.js', {}).then(function () { return setOwner(''); }); }

  function save() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      cart().then(function (c) {
        if (!me) return;
        var owner = ownerOf(c);
        if (owner && owner !== me) return; // never someone else's cart
        var go = owner ? Promise.resolve() : setOwner(me);
        return go.then(cart).then(function (c2) {
          var attrs = c2.attributes || {};
          attrs[OWNER] = me;
          // The pickup fee is never saved: the pickup step owns it (one line, added there).
          var body = { lines: (c2.items || []).filter(function (i) { return i.handle !== 'pickup-fee'; }).map(function (i) { return { id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }; }), attributes: attrs, note: c2.note || '' };
          return call(url, body);
        });
      }).catch(function () {});
    }, 700);
  }

  function addAll(lines) {
    // A pickup fee line saved before 2026-10-07 is never brought back (it carries the chooser's _Pickup-* properties).
    var items = lines.filter(function (l) { var pr = l.properties || {}; return !pr['_Pickup-Source'] && !pr['_Pickup-Location-Id']; }).map(function (l) { return { id: l.id, quantity: l.quantity, properties: l.properties || {} }; });
    return call('/cart/add.js', { items: items }).then(function (r) {
      if (r.ok) return;
      // One sold-out line refuses the whole batch — add them one by one and keep what can be had.
      return items.reduce(function (p, it) { return p.then(function () { return call('/cart/add.js', { items: [it] }).catch(function () {}); }); }, Promise.resolve());
    });
  }
  function load(saved) {
    try { sessionStorage.setItem('swr-cart-restored', me); } catch (e) {}
    return addAll(saved.lines).then(function () {
      var attrs = saved.attributes || {};
      attrs[OWNER] = me;
      return call('/cart/update.js', { attributes: attrs, note: saved.note || '' });
    });
  }

  // Save after the theme's own cart calls (never during our own work).
  window.fetch = function (input, init) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (cfg.signedIn && !busy && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u)) p.then(function (r) { if (r && r.ok) save(); }).catch(function () {});
    return p;
  };

  busy = true;
  cart().then(function (c) {
    var owner = ownerOf(c);
    // SIGNED OUT: a customer's cart leaves this browser with them.
    if (!cfg.signedIn) {
      if (!owner) return;
      return wipe().then(function () { location.reload(); });
    }
    return tagOf(cfg.customer).then(function (tag) {
      me = tag;
      return call(url).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }).then(function (s) {
        var saved = s && s.cart && s.cart.lines && s.cart.lines.length ? s.cart : null;
        var tried = false;
        try { tried = sessionStorage.getItem('swr-cart-restored') === me; } catch (e) {}
        // Someone else's cart in this browser: out it goes, theirs comes in.
        if (owner && owner !== me) return wipe().then(function () { return saved ? load(saved) : null; }).then(function () { location.reload(); });
        // Empty here: bring theirs, once per visit.
        if (!c.item_count) { if (saved && !tried) return load(saved).then(function () { location.reload(); }); return; }
        // A guest's cart and a saved one of theirs: theirs wins (never adopt a stranger's cart over it).
        if (!owner && saved && !tried) return wipe().then(function () { return load(saved); }).then(function () { location.reload(); });
        // Theirs (or a guest cart they now own): keep it saved.
        busy = false;
        save();
      });
    });
  }).catch(function () {}).then(function () { busy = false; });
})();
